/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type KeepOutZonesQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type KeepOutZonesQuery = {
  __typename?: 'Query'
  keepOutZones: Array<{
    __typename?: 'KeepOutZone'
    id: string
    geometry: string
    name: string
    reason: Types.RoadBlockageReason
  }>
}

export type KeepOutZonePolygonAreaFragment = {
  __typename?: 'KeepOutZone'
  id: string
  geometry: string
  name: string
  reason: Types.RoadBlockageReason
}

export type KeepOutZoneInfoCardAreaFragment = {
  __typename?: 'KeepOutZone'
  id: string
  name: string
  reason: Types.RoadBlockageReason
}

export const KeepOutZoneInfoCardAreaFragmentDoc = gql`
    fragment KeepOutZoneInfoCardArea on KeepOutZone {
  id
  name
  reason
}
    `
export const KeepOutZonePolygonAreaFragmentDoc = gql`
    fragment KeepOutZonePolygonArea on KeepOutZone {
  id
  geometry
  ...KeepOutZoneInfoCardArea
}
    `
export const KeepOutZonesDocument = gql`
    query KeepOutZones($regionId: ID!) {
  keepOutZones(regionId: $regionId, filter: {statuses: [Active]}) {
    id
    ...KeepOutZonePolygonArea
  }
}
    ${KeepOutZonePolygonAreaFragmentDoc}
${KeepOutZoneInfoCardAreaFragmentDoc}`

/**
 * __useKeepOutZonesQuery__
 *
 * To run a query within a React component, call `useKeepOutZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeepOutZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeepOutZonesQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useKeepOutZonesQuery(
  baseOptions: Apollo.QueryHookOptions<
    KeepOutZonesQuery,
    KeepOutZonesQueryVariables
  > &
    (
      | { variables: KeepOutZonesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<KeepOutZonesQuery, KeepOutZonesQueryVariables>(
    KeepOutZonesDocument,
    options,
  )
}
export function useKeepOutZonesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    KeepOutZonesQuery,
    KeepOutZonesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<KeepOutZonesQuery, KeepOutZonesQueryVariables>(
    KeepOutZonesDocument,
    options,
  )
}
// @ts-ignore
export function useKeepOutZonesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    KeepOutZonesQuery,
    KeepOutZonesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<KeepOutZonesQuery, KeepOutZonesQueryVariables>
export function useKeepOutZonesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        KeepOutZonesQuery,
        KeepOutZonesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  KeepOutZonesQuery | undefined,
  KeepOutZonesQueryVariables
>
export function useKeepOutZonesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        KeepOutZonesQuery,
        KeepOutZonesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<KeepOutZonesQuery, KeepOutZonesQueryVariables>(
    KeepOutZonesDocument,
    options,
  )
}
export type KeepOutZonesQueryHookResult = ReturnType<
  typeof useKeepOutZonesQuery
>
export type KeepOutZonesLazyQueryHookResult = ReturnType<
  typeof useKeepOutZonesLazyQuery
>
export type KeepOutZonesSuspenseQueryHookResult = ReturnType<
  typeof useKeepOutZonesSuspenseQuery
>
export type KeepOutZonesQueryResult = Apollo.QueryResult<
  KeepOutZonesQuery,
  KeepOutZonesQueryVariables
>
